export var createUnhandledRejection = function createUnhandledRejection(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (coolingOffPeriod) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.clearInterval === undefined || window.setInterval === undefined) {
        return emitNotSupportedError(observer);
      }

      var possiblyUnhandledRejections = new Map();
      var intervalId = null;

      var deletePossiblyUnhandledRejection = function deletePossiblyUnhandledRejection(_ref) {
        var promise = _ref.promise;
        return possiblyUnhandledRejections.delete(promise);
      };

      var emitUnhandledRejection = function emitUnhandledRejection() {
        var latestTimestampToEmit = Date.now() - coolingOffPeriod;
        possiblyUnhandledRejections.forEach(function (_ref2, promise) {
          var reason = _ref2.reason,
              timestamp = _ref2.timestamp;

          if (timestamp > latestTimestampToEmit) {
            return;
          }

          possiblyUnhandledRejections.delete(promise);
          observer.next(reason);
        });

        if (intervalId !== null && possiblyUnhandledRejections.size === 0) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
      };

      var registerPossiblyUnhandledRejection = function registerPossiblyUnhandledRejection(event) {
        event.preventDefault();
        possiblyUnhandledRejections.set(event.promise, {
          reason: event.reason,
          timestamp: Date.now()
        });

        if (intervalId === null) {
          intervalId = window.setInterval(emitUnhandledRejection, coolingOffPeriod / 2);
        }
      };

      window.addEventListener('rejectionhandled', deletePossiblyUnhandledRejection);
      window.addEventListener('unhandledrejection', registerPossiblyUnhandledRejection);
      return function () {
        if (intervalId !== null) {
          window.clearInterval(intervalId);
        }

        window.removeEventListener('rejectionhandled', deletePossiblyUnhandledRejection);
        window.removeEventListener('unhandledrejection', registerPossiblyUnhandledRejection);
      };
    });
  };
};